import { render, staticRenderFns } from "./RegisterSelectPage.vue?vue&type=template&id=9bc9661c&scoped=true"
import script from "./RegisterSelectPage.vue?vue&type=script&lang=js"
export * from "./RegisterSelectPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc9661c",
  null
  
)

export default component.exports